<img [src]="imageUrl" style="display: none;" />